import {
  Box,
  Color,
  Display,
  DisplayPosition,
  FlexDirection,
  Overflow,
  Space,
  ZIndex,
} from '@gousto-internal/citrus-react'
import React from 'react'

import {
  CTABlock,
  ChickPeasPattern,
  ChickPeasPatternWide,
  DonationSection,
  EcoChillBoxImage,
  EnvironmentalBenefitsCopy,
  HeaderSection,
} from './components'

import BottomChickPeas from '../../assets/EnviromentalBenefitsSectionAssets/BottomChickPeas.png'
import TopChickPeas from '../../assets/EnviromentalBenefitsSectionAssets/TopChickPeas.png'
import WideChickPeas from '../../assets/EnviromentalBenefitsSectionAssets/WideChickPeas.png'
import XWideChickPeas from '../../assets/EnviromentalBenefitsSectionAssets/XWideChickPeas.png'

import { ENVIRONMENTAL_BENEFITS_BULLET_ONE, ENVIRONMENTAL_BENEFITS_BULLET_TWO } from '../../config'

export type EnvironmentalBenefitsSectionProps = {
  signupCTA: string
  onCTAClick: () => void
}

export const EnvironmentalBenefitsSection = ({
  signupCTA,
  onCTAClick,
}: EnvironmentalBenefitsSectionProps) => (
  <Box
    display={Display.Flex}
    flexDirection={[FlexDirection.Column, null, FlexDirection.Row]}
    bg={Color.NeutralGrey_50}
    maxHeight={['100%', null, null, '570px']}
    position={DisplayPosition.Relative}
    overflowY={Overflow.Hidden}
  >
    <ChickPeasPattern topSpace="0" chickPeasImage={TopChickPeas} />
    <Box zIndex={ZIndex.Mask} paddingH={[4, 12, 4, 12]} paddingV={[14, 14, 16]} flexBasis="50%">
      <HeaderSection />
      <Space size={4} />
      <Box display={Display.Flex} flexDirection={FlexDirection.Column}>
        <EnvironmentalBenefitsCopy
          ENVIRONMENTAL_BENEFITS_BULLET={ENVIRONMENTAL_BENEFITS_BULLET_ONE}
        />
        <Space size={2} />
        <EnvironmentalBenefitsCopy
          ENVIRONMENTAL_BENEFITS_BULLET={ENVIRONMENTAL_BENEFITS_BULLET_TWO}
        />
      </Box>
      <Space size={4} />
      <CTABlock signupCTA={signupCTA} onCTAClick={onCTAClick} />
      <Space size={4} />
      <DonationSection />
    </Box>
    <Box position={DisplayPosition.Relative} flexBasis="50%">
      <ChickPeasPatternWide display={['none', 'none', 'block', 'none']} src={WideChickPeas} />
      <ChickPeasPatternWide display={['none', 'none', 'none', 'block']} src={XWideChickPeas} />
      <ChickPeasPattern topSpace="-90px" chickPeasImage={BottomChickPeas} />
      <EcoChillBoxImage />
    </Box>
  </Box>
)
